import React from "react";
import PropTypes from "prop-types";

import { useStyles } from "./styles";
import { Typography } from "@material-ui/core";

export default function InputMediaCard(props) {
  const classes = useStyles();

  return (
    <div className={classes.imageCardWrapper}>
      <div
        className={`${classes.cardInput} ${props.selected && classes.selected} ${props.icon && classes.withIcon} ${props.disabled &&
          classes.disabled} ${props.cardInput && props.cardInput} ${classes.minSize}`}
        onClick={!props.disabled ? props.onClick : () => {}}
      >
        <Typography className={classes.title} variant="subtitle1">
        {props.mainTitle} {props.title}
        </Typography>
        {props.icon && <div className={classes.imageWrapper}>{props.icon}</div>}
      </div>
      {props.labelImg && <div className={classes.labelImageWrapper}>{props.labelImg}</div>}
    </div>
  );
}

InputMediaCard.propTypes = {
  icon: PropTypes.any,
  class: PropTypes.string,
  title: PropTypes.string,
  selected: PropTypes.bool,
  onClick: PropTypes.func,
  mainTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  disabled: PropTypes.bool,
  labelImg: PropTypes.any,
  cardInput: PropTypes.string
};
